import graphql__12b9e75cd790962c6919 from "./__generated__/CityWalkWaypointContributionFormRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ModalLoader from "../Modals/ModalLoader";
import CityWalkWaypointContributionForm from "../CityWalks/CityWalkWaypointContributionForm";

const CityWalkWaypointContributionFormRoute = props => {
  const { participativeModuleSlug, cityWalkWaypointId } = useParams();

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={CityWalkWaypointContributionFormRouteQuery}
      variables={{ participativeModuleSlug, cityWalkWaypointId }}
      component={CityWalkWaypointContributionForm}
      loader={<ModalLoader />}
      additionalProps={props}
    />
  );
};

const CityWalkWaypointContributionFormRouteQuery = graphql__12b9e75cd790962c6919;

export default CityWalkWaypointContributionFormRoute;
